/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { storesClient } from '../api/stores/storesClient';
import {
    StoresActions,
    StoresActionType,
    fetchStoresListSuccessAction,
    fetchStoresListErrorAction,
    downloadStoresListAsExcelSuccessAction,
    downloadStoresListAsExcelErrorAction,
} from '../actions/storesActions';
import { StoresState } from '../reducers/storesReducer';
import { StoresListRequestParams } from '../api/stores/storesClientTypings';
import { AxiosError } from 'axios';
import { parseError } from '../../utils/utils';
import { i18n } from '../translation/i18n';

export const getStoresListEpic: Epic<StoresActions> = (action$, state) => {
    return action$.pipe(
        ofType(StoresActionType.FETCH_NEXT_PAGE_START, StoresActionType.APPLY_FILTERS),
        switchMap(() => {
            const queryParams = makeStoresListRequestParamsFromState(state.value.storesReducer);

            return from(storesClient.listStores(queryParams)).pipe(
                map((resp) => fetchStoresListSuccessAction(resp)),

                catchError((err: AxiosError) =>
                    of(
                        fetchStoresListErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.storesListNotFound')),
                        ),
                    ),
                ),

                takeUntil(action$.pipe(ofType(StoresActionType.EXIT_REGISTRY_STORES_LIST_PAGE))),
            );
        }),
    );
};

function makeStoresListRequestParamsFromState(state: StoresState): StoresListRequestParams {
    return {
        ...state.filterParams,
        limit: state.limit,
        afterKey: state.afterKey,
    };
}

export const storesListDownloadEpic: Epic<StoresActions> = (action$, state) => {
    return action$.pipe(
        ofType(StoresActionType.DOWNLOAD_EXCEL),
        switchMap(() => {
            return from(storesClient.downloadStoresListAsExcel({ ...state.value.storesReducer.filterParams })).pipe(
                map(() => downloadStoresListAsExcelSuccessAction()),

                catchError((err: AxiosError) =>
                    of(
                        downloadStoresListAsExcelErrorAction(
                            parseError(err, i18n.t('downloadings.errors.requestToCreateFileFailed')),
                        ),
                    ),
                ),
                takeUntil(action$.pipe(ofType(StoresActionType.EXIT_REGISTRY_STORES_LIST_PAGE))),
            );
        }),
    );
};
